module.exports = [["cat","Katze"],["dogSmall","Hund klein"],["dog","Hund mittel"],["dogBig","Hund gross"],["rodent","Nager"],["horse","Pferd"],["ponny","Ponny"],["reptile","Reptil"],["fish","Fisch"],["amphibians","Amphibie"],["bird","Vogel"]]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Animals.json
// module id = 226
// module chunks = 0